import { styled } from "simplydo/react/styled";

import { headingBaseClass } from "../header/Header.styles";
import { Icon } from "../icon/Icon";

export const AccordionTitleIcon = styled(Icon)``;

export const AccordionTitleLabel = styled.div<{ $position: "left" | "right" }>`
  display: flex;
  align-items: center;
  justify-self: ${({ $position }) =>
    $position === "left" ? "flex-start" : "flex-end"};
  gap: 0.3rem;
`;

export const AccordionTitleContent = styled.div`
  display: flex;
  align-items: center;
  gap: 0.3rem;
`;

export const StyledAccordionTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  cursor: pointer;
  padding: 0;

  gap: 0.3rem;
  font-size: 1em;
  color: rgba(0, 0, 0, 0.87);
  font-weight: normal;
  margin: 0;
  transition:
    background 0.1s ease,
    color 0.1s ease;
  border-top: none;

  &:hover,
  &.is-active {
    color: rgba(0, 0, 0, 0.87);
  }

  &.is-active {
    color: rgba(0, 0, 0, 0.95);
  }

  .${headingBaseClass} {
    margin: 0;
  }

  ${AccordionTitleIcon} {
    transform: rotate(-90deg);
    transition: transform 0.1s ease;
  }

  &.is-active ${AccordionTitleIcon} {
    transform: rotate(0deg);
  }
`;

export const StyledAccordionContent = styled.div`
  display: none;
  margin: 0;
  padding: 0.5em 0 1em;

  &.is-active {
    display: block;
  }
`;

export const StyledAccordion = styled.div`
  max-width: 100%;
  font-family: inherit;

  &.is-fluid {
    width: 100%;
  }

  &.is-styled {
    width: 600px;
    max-width: 100%;
    border-radius: 0.28571429rem;
    background: #ffffff;
    box-shadow:
      0px 1px 2px 0 rgba(34, 36, 38, 0.15),
      0px 0px 0px 1px rgba(34, 36, 38, 0.15);
  }

  &.is-styled.is-fluid {
    width: 100%;
  }

  &.is-styled ${StyledAccordionTitle} {
    gap: 0.5rem;
    padding: 1em;
    color: rgba(0, 0, 0, 0.4);
    font-weight: bold;
    border-top: 1px solid rgba(34, 36, 38, 0.15);

    ${AccordionTitleIcon} {
      margin-right: 0.2rem;
    }

    &:hover,
    &.is-active {
      color: rgba(0, 0, 0, 0.95);
    }
  }

  > ${StyledAccordionTitle}:first-child {
    border-top: none;
  }

  &.is-styled ${StyledAccordionContent} {
    padding: 0.5em 1em 1.5em;
  }
`;
